export default __webpack_public_path__ + "static/media/pagebanner3.4a23e19b.jpg";